import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getNetworkState, NetworkError, networkInitialState, NetworkStatuses } from 'store/network';
import { RoughWorkState, TConfigurator } from './types';
import { useActions as useDispatchActionHook } from '../../common/hooks';
import { sliceKey as name } from './utils';

export const initialState: RoughWorkState = {
	data: {
		leadId: '',
		configurators: [],
	},
	network: networkInitialState,
};

export const RoughWorkSlice = createSlice({
	name,
	initialState,
	reducers: {
		fetchConfiguratorsRequest(state) {
			state.network = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchConfiguratorsSuccess(
			state,
			action: PayloadAction<{ configurators: TConfigurator[] }>
		) {
			const { configurators } = action.payload;
			state.data.configurators = configurators;
			state.network = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchConfiguratorsFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.network = getNetworkState(NetworkStatuses.FAILED, error);
		},
	},
});

export const {
	actions: roughWorkActions,
	reducer: roughWorkReducer,
	name: roughWorkName,
} = RoughWorkSlice;

export const useDispatchRoughWorkAction = () => useDispatchActionHook(roughWorkActions);
export const {
	fetchConfiguratorsFailed,
	fetchConfiguratorsRequest,
	fetchConfiguratorsSuccess,
} = roughWorkActions;

export const roughWorkState = initialState;
